// import clevertap from "clevertap-web-sdk";
import { REACT_APP_CLEVERTAP_ACCOUNT_ID } from "../utils/environment";

const initializeCleverTap = () => {
  // Privacy settings FIRST
  window.clevertap.privacy.push({ useIP: true });

  // Initialize
  window.clevertap.init(REACT_APP_CLEVERTAP_ACCOUNT_ID, "in1");

  console.log("CleverTap initialized ");

  window.clevertap.spa = true;
};

export default initializeCleverTap;